import { useEffect, useState } from "react";
import api from "@api";
import "./SeasonList.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext.jsx"; // adjust path if needed

function SeasonList() {
  const [seasons, setSeasons] = useState([]);
  const [seasonForm, setSeasonForm] = useState({
    name: "",
    startDate: "",
    finishDate: "",
    active: true,
    copyFromSeasonId: "" // 🆕 optional
  });
  const { user } = useAuth();
  const [updateForm, setUpdateForm] = useState({ id: null, name: "", startDate: "", finishDate: "", active: true });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedSeasons, setSelectedSeasons] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        const res = await api.get("/api/seasonsv2", { withCredentials: true });
        setSeasons(res.data.seasons || []);
        console.log(res.data.seasons)
      } catch (err) {
        console.error("Error fetching seasons:", err);
      } finally {
        setLoading(false); // ✅ Only after fetch completes
      }
    };
    fetchSeasons();
  }, []);


  const handleCreateSeason = async (e) => {
    e.preventDefault();
    try {
      const sport_id = user?.sports?.length === 1 ? user.sports[0].id : null;
      if (!sport_id) {
        alert("No sport assigned to this user.");
        return;
      }

      const payload = {
        ...seasonForm,
        sport_id, // ✅ inject here
      };

      console.log("Creating season with:", payload);

      const res = await api.post("/api/seasonsv2", payload, {
        withCredentials: true,
      });

      setSeasons((prev) => [...prev, res.data.season]);
      setSeasonForm({
        name: "",
        startDate: "",
        finishDate: "",
        active: true,
        sport_id, // ✅ preserve sport after reset
      });
      setIsModalOpen(false);
      setMessage(`${res.data.season.name} created`);
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Create error:", err);
    }
  };



  const handleUpdateSeason = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put(`/api/seasonsv2/${updateForm.id}`, updateForm, { withCredentials: true });
      const updated = await api.get("/api/seasonsv2", { withCredentials: true });
      setSeasons(updated.data.seasons || []);
      setIsUpdateModalOpen(false);
      setMessage(`${res.data.season.name} updated`);
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Update error:", err);
    }
  };

  const handleDeleteSeasons = async () => {
    if (!selectedSeasons.length) return alert("Select at least one season to delete.");
    if (!window.confirm("Delete selected seasons?")) return;
    try {
      await Promise.all(
        selectedSeasons.map((id) => api.delete(`/api/seasonsv2/${id}`, { withCredentials: true }))
      );
      setSeasons((prev) => prev.filter((s) => !selectedSeasons.includes(s.id)));
      setSelectedSeasons([]);
      setMessage("Seasons deleted");
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const openUpdateModal = (season) => {
    setUpdateForm({
      id: season.id,
      name: season.name,
      startDate: season.startDate,
      finishDate: season.finishDate,
      active: season.active,
    });
    setIsUpdateModalOpen(true);
  };

  const handleCheckboxChange = (id) => {
    setSelectedSeasons((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedSeasons.length === seasons.length) {
      setSelectedSeasons([]);
    } else {
      setSelectedSeasons(seasons.map((s) => s.id));
    }
  };


  const formatDatePure = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("T")[0].split("-");
    return `${month}-${day}-${year}`;
  };

  const toDateInputValue = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.split("T")[0]; // grabs just the YYYY-MM-DD part
  };



  const isSuperAdmin = user?.role === "super_admin";

  return (
    <div className="season_auth_container">
      <div className="season-btn-container">
        <button className="delete-season-btn" onClick={handleDeleteSeasons}>🗑️</button>
        <h2>SEASONS</h2>
        <button className="add-season-btn" onClick={() => setIsModalOpen(true)}>+ Add Season</button>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Create Season</h3>
            <form onSubmit={handleCreateSeason}>
              <input type="text" value={seasonForm.name} placeholder="Season name" onChange={(e) => setSeasonForm({ ...seasonForm, name: e.target.value })} required />
              <input type="date" value={seasonForm.startDate} onChange={(e) => setSeasonForm({ ...seasonForm, startDate: e.target.value })} />
              <input type="date" value={seasonForm.finishDate} onChange={(e) => setSeasonForm({ ...seasonForm, finishDate: e.target.value })} />
              {/* <label>
        Copy Leagues From:
        <select
         value={seasonForm.copyFromSeasonId}
         onChange={(e) => setSeasonForm({ ...seasonForm, copyFromSeasonId: e.target.value })}
        >
         <option value="">None</option>
         {seasons.map((s) => (
          <option key={s.id} value={s.id}>
           {s.name}
          </option>
         ))}
        </select>
       </label> */}
              <label>
                Active: 
                <input type="checkbox" checked={seasonForm.active} onChange={(e) => setSeasonForm({ ...seasonForm, active: e.target.checked })} />
              </label>
              <button type="submit">Create</button>
              <button type="button" onClick={() => setIsModalOpen(false)}>Cancel</button>
            </form>
          </div>
        </div>
      )}

      {isUpdateModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Update Season</h3>
            <form onSubmit={handleUpdateSeason}>
              <input type="text" value={updateForm.name} onChange={(e) => setUpdateForm({ ...updateForm, name: e.target.value })} required />
              <input
                type="date"
                value={updateForm.startDate ? toDateInputValue(updateForm.startDate) : ""}
                onChange={(e) => setUpdateForm({ ...updateForm, startDate: e.target.value })}
              />

              <input
                type="date"
                value={updateForm.finishDate ? toDateInputValue(updateForm.finishDate) : ""}
                onChange={(e) => setUpdateForm({ ...updateForm, finishDate: e.target.value })}
              />


              <label>
                Active:
                <input type="checkbox" checked={updateForm.active} onChange={(e) => setUpdateForm({ ...updateForm, active: e.target.checked })} />
              </label>
              <button type="submit">Update</button>
              <button type="button" onClick={() => setIsUpdateModalOpen(false)}>Cancel</button>
            </form>
          </div>
        </div>
      )}

      {message && <p className="message">{message}</p>}

      <table className="season-table">
        <thead>
          <tr>
            <th><input type="checkbox" checked={selectedSeasons.length === seasons.length} onChange={handleSelectAll} /></th>
            <th>ID</th>
            <th>Name</th>
            {isSuperAdmin && <th>Organization</th>}
            {isSuperAdmin && <th>Sport</th>}
            <th>Start</th>
            <th>Finish</th>
            <th>Active</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {loading ? null :
            seasons.length === 0 ? (
              <tr><td colSpan="6">No seasons available</td></tr>
            ) : (
              seasons.map((season, i) => (
                <tr key={season.id}>
                  <td><input type="checkbox" checked={selectedSeasons.includes(season.id)} onChange={() => handleCheckboxChange(season.id)} /></td>
                  <td>{i + 1}</td>
                  <td className='season-name-link' onClick={() => navigate(`/dashboard/seasons/${season.id}`)}>{season.name}</td>
                  {isSuperAdmin && <td>{season.organization.name}</td>}
                  {isSuperAdmin && <td>{season.sportsv2.type}</td>}
                  <td>{formatDatePure(season.startDate)}</td>

                  <td>{formatDatePure(season.finishDate)}</td>

                  <td>{season.active ? "✅" : "❌"}</td>
                  <td>
                    <button className="season-update-btn" onClick={() => openUpdateModal(season)}>✏️ EDIT</button>
                  </td>
                </tr>
              ))
            )}
        </tbody>
      </table>
    </div>
  );
}

export default SeasonList;
